import * as React from "react";

export default function Dashboard(props) {
  // const [open, setOpen] = React.useState(false);

  return <div> {props.children}</div>;
}
